import React from 'react';

import {
  Box,
  Flex,
  Badge,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useColorMode,
  Image,
} from '@chakra-ui/core';
import { Link } from 'react-router-dom';
import {
  FaHamburger,
  FaShoppingCart,
  FaMoon,
  FaSun,
  FaChevronDown,
} from 'react-icons/fa';

import {
  BiCurrentLocation,
  BiLogOutCircle,
  BiInfoCircle,
  BiStar,
  BiShoppingBag,
} from 'react-icons/bi';

import { connect } from 'react-redux';

import Login from '../auth/Login';
import Register from '../auth/Register';

import Search from './Search';

import logo from '../../images/logo1.png';

import { logout } from '../../redux/actions/authAction';
import { getLocation } from '../../redux/actions/locAction';

function useWindowSize() {
  const [size, setSize] = React.useState([0, 0]);
  React.useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

function ShopBadge(props) {
  return (
    <Link onClick={props.handleToggle} to="/cart">
      <Box cursor="pointer" mt={{ base: '15px', md: '0' }} display="flex">
        <FaShoppingCart fontSize="28px"></FaShoppingCart>
        <Badge rounded="20px" fontSize="18px" ml="1" colorScheme="red">
          {props.itemNumber}
        </Badge>
      </Box>
    </Link>
  );
}

const Navbar = props => {
  const [width] = useWindowSize();

  const { colorMode, toggleColorMode } = useColorMode();
  const color = { light: 'gray.800', dark: 'white' };

  const [show, setShow] = React.useState(false);
  const handleToggle = () => {
    setShow(!show);
    if (show) {
      setScrollState('top');
    }
  };

  const [scrollState, setScrollState] = React.useState('top');
  React.useEffect(() => {
    let listener = null;
    navigator.geolocation.getCurrentPosition(function (position) {
      props.getLocation(position.coords.latitude, position.coords.longitude);
    });

    listener = document.addEventListener('scroll', e => {
      let scrolled = document.scrollingElement.scrollTop;

      if (scrolled >= 300) {
        if (scrollState !== 'amir' || width <= 1000) {
          setScrollState('amir');
        }
      } else {
        if (scrollState !== 'top') {
          setScrollState('top');
        }
      }
    });
    return () => {
      document.removeEventListener('scroll', listener);
    };
  }, [scrollState, width, props]);

  const allowLocation = () => {
    navigator.geolocation.getCurrentPosition(function (position) {
      props.getLocation(position.coords.latitude, position.coords.longitude);
    });
  };

  return (
    <Flex
      style={{
        position: 'fixed',
        width: '100%',
        zIndex: '99',
        top: 0,
        backgroundColor:
          scrollState === 'amir' || width <= 1000 ? '#000' : '#00000059',
      }}
      //   style={{
      //     backgroundColor: scrollState === 'top' ? 'red' : 'green',
      //     color: scrollState === 'top' ? 'white' : 'blue',
      //     position: 'fixed',
      //   }}
      as="nav"
      align="center"
      justify="space-between"
      wrap="wrap"
      padding="0.5rem"
      //   bg="black"
      //   {...props}
      color="white"
    >
      <Flex w="auto" align="center" mr={5}>
        <Link to="/">
          <Image cursor="pointer" w="230px" src={logo}></Image>
        </Link>
      </Flex>

      <Box display={{ base: 'block', md: 'none' }} onClick={handleToggle}>
        <FaHamburger fontSize="24px"></FaHamburger>
      </Box>

      <Box
        display={{ base: show ? 'block' : 'none', md: 'flex' }}
        width={{ base: 'full', md: 'auto' }}
        alignItems="center"
        justifyContent="flex-end"
        flexGrow={1}
      >
        {!(scrollState === 'top') && <Search nav={true}></Search>}
        <Text
          onClick={handleToggle}
          mt={{ base: 4, md: 0 }}
          mr={6}
          display="block"
          fontSize="18px"
        >
          <Link to="/restaurants">Découvrir</Link>
        </Text>
        {props.auth.data && (
          <>
            <Menu>
              <MenuButton
                px={4}
                py={2}
                mt={{ base: 4, md: 0 }}
                mr={6}
                fontSize="lg"
                transition="all 0.2s"
                rounded="md"
                _hover={{ bg: 'gray.100', color: 'black' }}
                _focus={{ outline: 0, boxShadow: 'outline' }}
              >
                Compte{' '}
                <FaChevronDown style={{ display: 'inline' }}></FaChevronDown>
              </MenuButton>
              <MenuList shadow="xl">
                <Link to="/profile">
                  <MenuItem onClick={handleToggle} fontSize="lg">
                    <Box color={color[colorMode]} display="flex">
                      <Box mr="2" fontSize="24px">
                        <BiInfoCircle></BiInfoCircle>
                      </Box>
                      <Text>profil</Text>
                    </Box>
                  </MenuItem>
                </Link>
                <Link to="/favories">
                  <MenuItem onClick={handleToggle} fontSize="lg">
                    <Box color={color[colorMode]} display="flex">
                      <Box mr="2" fontSize="24px">
                        <BiStar></BiStar>
                      </Box>
                      <Text>Favories</Text>
                    </Box>
                  </MenuItem>
                </Link>
                <Link to="/orders">
                  <MenuItem onClick={handleToggle} fontSize="lg">
                    <Box color={color[colorMode]} display="flex">
                      <Box mr="2" fontSize="24px">
                        <BiShoppingBag></BiShoppingBag>
                      </Box>
                      <Text>Ordres</Text>
                    </Box>
                  </MenuItem>
                </Link>
                <Box
                  onClick={() => {
                    props.logout();
                    handleToggle();
                  }}
                  cursor={'pointer'}
                  fontSize="lg"
                >
                  <MenuItem>
                    <Box color={color[colorMode]} display="flex">
                      <Box mr="2" fontSize="24px">
                        <BiLogOutCircle></BiLogOutCircle>
                      </Box>
                      <Text>Se déconnecter</Text>
                    </Box>
                  </MenuItem>
                </Box>
              </MenuList>
            </Menu>
          </>
        )}
        {!props.auth.data && (
          <>
            <Register></Register>
            <Login></Login>
          </>
        )}
        <ShopBadge
          handleToggle={handleToggle}
          itemNumber={props.cart.cartItemNumber}
        ></ShopBadge>
        <Box
          onClick={() => allowLocation()}
          cursor="pointer"
          ml={['0', '0', '6', '6']}
          mt={['6', '6', '0', '0']}
          fontSize="28px"
        >
          <BiCurrentLocation></BiCurrentLocation>
        </Box>
        <Box
          cursor="pointer"
          mr={['0', '0', '6', '6']}
          ml={['0', '0', '6', '6']}
          mt={['6', '6', '0', '0']}
          fontSize="24px"
          onClick={() => {
            toggleColorMode();
            handleToggle();
          }}
        >
          {' '}
          {colorMode === 'light' ? <FaMoon></FaMoon> : <FaSun></FaSun>}
        </Box>
      </Box>
    </Flex>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.auth,
    location: state.location,
    cart: state.cart,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(logout()),
    getLocation: (lat, long) => dispatch(getLocation(lat, long)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
